import { Card, CardContent, Typography, Box, Skeleton } from "@mui/material";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { CHART_COLORS, formatNumber } from "../constants";

interface CustomerGrowthChartProps {
  data: any;
  loading: boolean;
}

const CustomerGrowthChart = ({ data, loading }: CustomerGrowthChartProps) => {
  if (loading) {
    return (
      <Card sx={{ height: "100%", borderRadius: 2, boxShadow: "0 1px 3px 0 rgba(0,0,0,.1)" }}>
        <CardContent sx={{ p: 2.5 }}>
          <Skeleton width="40%" height={24} />
          <Skeleton width="100%" height={280} sx={{ mt: 2 }} />
        </CardContent>
      </Card>
    );
  }

  const chartData = data?.growthTrend || [];

  return (
    <Card sx={{ height: "100%", borderRadius: 2, boxShadow: "0 1px 3px 0 rgba(0,0,0,.1)" }}>
      <CardContent sx={{ p: 2.5 }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>
          Customer Growth
        </Typography>
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={280}>
            <LineChart data={chartData} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis
                dataKey="date"
                tick={{ fontSize: 11 }}
                tickFormatter={(val) => {
                  const d = new Date(val);
                  return `${d.getDate()}/${d.getMonth() + 1}`;
                }}
              />
              <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
              <Tooltip
                formatter={(value: any) => [formatNumber(value), "New Customers"]}
                labelFormatter={(label) => new Date(label).toLocaleDateString()}
                contentStyle={{ borderRadius: 8, fontSize: 13 }}
              />
              <Line
                type="monotone"
                dataKey="newCustomers"
                stroke={CHART_COLORS.teal}
                strokeWidth={2.5}
                dot={{ r: 3, fill: CHART_COLORS.teal }}
                activeDot={{ r: 5 }}
              />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <Box sx={{ height: 280, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Typography color="text.secondary">No customer data</Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default CustomerGrowthChart;
